import React from "react";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import PropTypes from "prop-types";

export default function ConditionSalesOrderCheckbox(props) {
    const { defaultValue } = props

    const [state, setState] = React.useState({
        OnlyThePending: false,
        OnlyApprovedReference: false,
        OnlyUnapprovedReferences: false,
    });

    React.useEffect(async () => {

        props.resSelect(state)
        return () => {
        }
    }, [state])


    const handleChange = (event) => {
        setState({
            ...state,
            [event.target.name]: event.target.checked,
        });
    };

    const { OnlyThePending, OnlyApprovedReference, OnlyUnapprovedReferences } = state;
    return (
        <>
            <FormGroup row>
                <FormControlLabel control={<Checkbox name="OnlyThePending" checked={OnlyThePending} onChange={handleChange} />} label="เฉพาะที่ค้าง" />
                <FormControlLabel control={<Checkbox name="OnlyApprovedReference" checked={OnlyApprovedReference} onChange={handleChange} />} label="เฉพาะที่อนุมัติให้อ้างอิง" />
                <FormControlLabel control={<Checkbox name="OnlyUnapprovedReferences" checked={OnlyUnapprovedReferences} onChange={handleChange} />} label="เฉพาะที่ยังไม่อนุมัติให้อ้างอิง" />
            </FormGroup>
        </>
    )
}


ConditionSalesOrderCheckbox.propTypes = {
    defaultValue: PropTypes.array
}